export const calculateRankChange = (podcast) => {
  const historyRanks = podcast.historyRank;
  if (!historyRanks || historyRanks.length < 2) {
    return { change: 0, direction: 'none' };
  }

  const lastRank = parseInt(historyRanks[historyRanks.length - 1]?.rank);
  const prevRank = parseInt(historyRanks[historyRanks.length - 2]?.rank);
  const difference = prevRank - lastRank;

  if (difference === 0) {
    return { change: 0, direction: 'none' };
  }

  return {
    change: Math.abs(difference),
    direction: difference > 0 ? 'up' : 'down'
  };
};

export const findBestRankData = (podcastsData, country) => {
  if (!podcastsData || !Array.isArray(podcastsData)) {
    return null;
  }

  return podcastsData.reduce((best, item) => {
    const countryMatch = 
      item.country === country || 
      (item.country === 'UK' && country === 'United Kingdom') ||
      (item.country === 'United Kingdom' && country === 'UK');
    
    if (!countryMatch) return best;
    
    const lastRank = item.historyRank?.[item.historyRank.length - 1]?.rank;
    if (!lastRank) return best;
    
    const currentRank = Number(lastRank);
    
    if (!best || currentRank < Number(best.historyRank?.[best.historyRank.length - 1]?.rank)) {
      return item;
    }
    
    return best;
  }, null);
};